import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { dateToEpochString } from '@flipster/utils/datetime';

import { detailBunja } from './details';
import { updateV2SocketData } from './internal/v2-helper';
import { refDetailTimes } from './server-time';
import { r230522SocketBunja } from './socket';
import { WsV2TableEvent } from './types';

export type SpotDetails = Record<string, SpotDetail> | null;

export interface SpotDetail {
  midPrice?: string;
  askPrice: string;
  bidPrice: string;
  bboPriceTimestamp: string;
  isTradable: boolean;
}

function updateSpotDetails(prev: SpotDetails, wsData: WsV2TableEvent<SpotDetail>['data']) {
  const spotDetails = updateV2SocketData(prev || {}, wsData);
  if (spotDetails) {
    Object.entries(spotDetails).forEach(([key, value]) => {
      // 서버에서 타입 설정을 잘못해서 number 로 오는중
      refDetailTimes[key] = {
        refServerTimestamp: value.bboPriceTimestamp.toString(),
        refClientTimestamp: dateToEpochString(new Date()),
      };
    });
  }
  return spotDetails;
}

const spotDetailsAtom = atom<SpotDetails>(null);
export const spotDetailsBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);
  const { setCurrentSpotDetail } = bunja.use(detailBunja);
  function setCurrentSymbol(symbol: string | null = null) {
    setCurrentSpotDetail(symbol);
  }

  bunja.effect(() => {
    function handler(event: WsV2TableEvent<SpotDetail>) {
      if (!event.data) return;
      store.set(spotDetailsAtom, (prev) => updateSpotDetails(prev, event.data));
    }

    r230522Socket.on('market/spot-details', handler);

    return () => {
      setCurrentSymbol(null);
      r230522Socket.off('market/spot-details', handler);
    };
  });

  return {
    spotDetailsAtom,
    setCurrentSymbol,
  };
});
spotDetailsBunja.debugLabel = 'spotDetailsBunja';
